import * as React from 'react';
import DataTable from "react-data-table-component";
import {Button} from 'reactstrap';

function paginationComponent(props) {
  console.log(props);
  return 'pagination';
}

interface ICardProps {
  data: any[];
  columns: any[];
  removeFromCustomMutant: (selectedRows: any[]) => void;
}
function MutantTable(props:ICardProps) {

  const removeFromCustomMutant = (row) => {
    props.removeFromCustomMutant(row);
    };
 
  return (
    <>

      <DataTable
        columns={[...props.columns, 
                  {
                    name: "",
                    cell: (row) => <Button onClick={() => removeFromCustomMutant(row)} style={{width: "100%",}}>-</Button>,
                    ignoreRowClick: true,
                    button: true,
                    width: "20px",
                  }
        ]}
        data={props.data}
        noHeader
        pagination={false}
        paginationPerPage={5}
        paginationRowsPerPageOptions={[5,10, 25, 100]}
        paginationIconFirstPage= {false}
        paginationIconLastPage= {false}
        dense
      />
    </>
  );
    
}

export default MutantTable;

